<template>
	<div class="brick">
		<div class="view_inner">
			<div class="divide_tbl">
				<table class="view_tbl" border="0">
					<colgroup>
						<col style="width:130px;" />
						<!-- <col style="width:400px;" /> -->
						<col style="" />
						<col style="width:130px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<tr>
							<th>Sample No</th>
							<td>
								<input type="text" v-model.trim="sample.sample_dn" class="tbl_int ssm2_int" readonly disabled />
							</td>
							<th></th>
							<td></td>
						</tr>
						<tr>
							<th>Status</th>
							<td>
								<CodeSelect className="tbl_select" :codes="sampleStatusCodes" :showDesc="true" :codeBold="true" :descBold="true" :disabled="true" v-model="sample.status_code" />
								<!-- <CodeSelect className="tbl_select" :codes="sampleStatusCodes" :showDesc="true" :codeBold="true" :descBold="true" v-model="sample.status_code" /> -->
								<!-- <CodeSelect className="tbl_select" :codes="sampleStatusCodes" :showDesc="false" v-model="status_code" /> -->
							</td>
							<th>Entry User</th>
							<td>
								<input type="text" v-model.trim="sample.crt_name" class="tbl_int ssm2_int" readonly disabled />
								<template v-if="sample.upd_dt"> &nbsp;Last updated : {{ sample.upd_dt | moment('MM-DD-YYYY HH:mm:ss') }} by {{ sample.upd_name }} </template>
							</td>
						</tr>
						<tr>
							<th>Entry Date</th>
							<td>
								<CustomDatePicker v-model="sample.entry_date" :disabled="mode == 'detail'" />
							</td>
							<th>Sales Group</th>
							<!-- <td><CodeSelect className="tbl_select" :codes="salesGroups" v-model="invoice.sales_group_code" /></td> -->
							<td><CodeSelect className="tbl_select" :codes="salesGroups" v-model="sample.sales_group_code" :disabled="mode == 'detail'" /></td>
						</tr>
						<tr>
							<th>Request Date</th>
							<td>
								<CustomDatePicker v-model="sample.request_date" disabled />
							</td>
							<th></th>
							<td></td>
						</tr>
						<tr>
							<th>Pick Up Date</th>
							<td colspan="3">
								<CustomDatePicker v-model="sample.pickup_date" disabled />
								by {{ sample.pickup_user }} at {{ sample.pickup_dt | moment('HH:mm:ss') }}
							</td>
							<!-- <th>Return Date</th>
							<td>
								<CustomDatePicker v-model="sample.return_date" disabled />
							</td> -->
						</tr>
						<tr>
							<th>Ready Date</th>
							<td colspan="3">
								<CustomDatePicker v-model="sample.ready_date" disabled />
							</td>
							<!-- <th>Return Date</th>
							<td>
								<CustomDatePicker v-model="sample.return_date" disabled />
							</td> -->
						</tr>

						<tr>
							<th>Description</th>
							<td colspan="3">
								<input type="text" v-model.trim="sample.description" class="tbl_int full_int" />
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<!-- New Item -->
			<div v-if="mode == 'add' || sample.status_code == 'E'" class="left_option" style="display:inline;">
				<span class="int_type half_int">
					<autocomplete ref="ac" :initialDisplay="keyword" :source="selectClasses" @nothingSelected="searchKeyword" @selected="selectClass" results-display="code_name" :placeholder="'Item / ' + headers.class + ' Name or Code'">
					</autocomplete>
				</span>

				<a href="javascript:;" class="search_bt" @click="search()">Search and Add Item(s)</a>
			</div>

			<div>
				<table class="list_tbl mgb_0 add_top_line" ref="sample_items">
					<thead>
						<tr>
							<th width="3%"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></th>
							<th width="10%">{{ headers.class }}</th>
							<th>Name</th>
							<th width="15%">Color</th>
							<th width="7%">Req. Qty.</th>
							<th v-if="mode == 'detail' && sample.status_code != 'E'" width="7%">Pick Qty.</th>
							<th width="7%">On Hand</th>
							<th width="7%">Available</th>
							<th width="7%">On Board</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in items" v-bind:key="item.sample_item_no">
							<td class="al_center"><input type="checkbox" v-model="item.selected" /></td>
							<td class="al_left">
								<template v-if="index == 0 || (index > 0 && item.class_code != items[index - 1].class_code)">
									{{ item.class_code }}
								</template>
							</td>
							<td class="al_left">
								<b v-if="item.active_yn == 'N'"><font color="red">!!</font></b>
								<a href="javascript:;" @click="selectItem(item)"
									><font :color="item.class_closed_yn == 'Y' ? 'gray' : 'black'">{{ item.name }}</font></a
								>
							</td>

							<td class="al_left">{{ item.color_code }}</td>
							<td class="al_right">
								<currency-input
									type="text"
									v-model.trim="item.request_quantity"
									:precision="0"
									class="r_int long_type al_right"
									@focus="$event.target.select()"
									:disabled="mode == 'detail' && sample.status_code != 'E'"
									ref="request_quantity"
									@keydown.down.prevent="goTo('request_quantity', index + 1)"
									@keydown.up.prevent="goTo('request_quantity', index - 1)"
									@keydown.enter.prevent="goTo('request_quantity', index + 1)"
								/>
							</td>
							<td v-if="mode == 'detail' && sample.status_code != 'E'" class="al_right">
								<currency-input
									type="text"
									v-model.trim="item.pick_quantity"
									:precision="0"
									class="r_int long_type al_right"
									@focus="$event.target.select()"
									ref="pick_quantity"
									@keydown.down.prevent="goTo('pick_quantity', index + 1)"
									@keydown.up.prevent="goTo('pick_quantity', index - 1)"
									@keydown.enter.prevent="goTo('pick_quantity', index + 1)"
								/>
							</td>
							<td class="al_right">{{ item.on_hand | commaSeparated }}</td>
							<td class="al_right">
								<span :style="item.quantity > 0 && item.quantity > item.available_quantity ? 'color:red;font-weight:bold;' : ''">{{ item.available_quantity | commaSeparated }}</span>
							</td>
							<td class="al_right">{{ item.on_board_quantity | commaSeparated }}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="tbl_bottom_bt">
				<input v-if="sample.status_code != 'D' && sample.status_code != 'T'" type="button" value="Delete" class="int_line_bt" @click="deleteItems()" />
				<span style="padding-left:20px"># of item row:</span>
				<input type="text" readonly disabled="disabled" style="width:40px;" class="r_int long_type al_right" v-model="items.length" />

				<input type="button" value="Copy" class="int_line_bt" style="margin-left:5px" @click="copyItems()" />
				<input v-if="sample.status_code != 'D' && sample.status_code != 'T'" type="button" value="Paste" class="int_line_bt" style="margin-left:5px" @click="pasteItems()" />
			</div>

			<div class="view_bottom_bt">
				<a
					v-if="(modifiable || ((sample.status_code == 'E' || sample.status_code == 'R') && (user.company_id == 'beautyplus' || user.company_id == 'hairplus'))) && sample.status_code != 'V'"
					href="javascript:;"
					type="button"
					class="search_bt"
					@click="save(false)"
					>Save & Return</a
				>
				<a
					v-if="(modifiable || ((sample.status_code == 'E' || sample.status_code == 'R') && (user.company_id == 'beautyplus' || user.company_id == 'hairplus'))) && sample.status_code != 'V'"
					href="javascript:;"
					type="button"
					class="search_bt mgr_15"
					@click="save(true)"
					>Save Only</a
				>
				<a v-if="mode === 'detail'" href="javascript: void (0);" type="button" class="search_bt mgr_15" @click="HistoryModalShowChange">History</a>
				<a v-if="mode === 'detail' && (modifiable || sample.status_code == 'R') && sample.status_code != 'E'" href="javascript: void (0);" type="button" class="search_bt mgr_15" @click="print()">Print</a>

				<a v-if="modifiable && sample.status_code == 'E'" href="javascript:;" type="button" class="search_bt" @click="request(false)">Request</a>
				<a v-if="modifiable && sample.status_code == 'R' && user.sample_approval" href="javascript:;" type="button" class="search_bt" @click="approve(false)">Approve</a>
				<a v-if="modifiable && sample.status_code == 'W'" href="javascript:;" type="button" class="search_bt" @click="ready(false)">Ready</a>
				<a v-if="false && modifiable && sample.status_code == 'D'" href="javascript:;" type="button" class="search_bt" @click="sreturn(false)">Return</a>

				<a v-if="modifiable && ['R', 'W', 'D'].includes(sample.status_code)" href="javascript:;" type="button" class="search_bt mgl_15 mgr_15" @click="makeVoid(false)">Void</a>
				<a v-if="modifiable && sample.status_code == 'E'" href="javascript:;" type="button" class="gray_bt mgl_15 " @click="deleteSample()">Delete</a>
			</div>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'ItemSelect'" :draggable="false" style="z-index:2000">
			<template slot="title">Select Item(s)</template>
			<template slot="body">
				<ItemPopupSample :initialItems="searchItems" :initialItemClass="this.itemClass" :initialKeyword="keyword" @close="closeModal()" @set-items="addItems" />
			</template>
		</Modal>
		<sample-history v-show="historyModal" :sample-history-list="sample.sampleHistoryList" @click="HistoryModalShowChange" />
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiIndex, apiSelectSample, apiInsertSample, apiUpdateSample, apiDeleteSample } from '@/api/sales/sample.js';
import { apiCheckInactiveItemExists } from '@/api/sales/invoice.js';
import CodeSelect from '@/components/common/CodeSelect';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import { today } from '@/utils/date.js';
import ItemPopupSample from '@/components/common/ItemPopupSample';
import Modal from '@/components/common/Modal';
import _ from 'lodash';
import 'floatthead';
import { reportMrtUrl, reportRenderBase64 } from '@/api/util';
import SampleHistory from '@/views/sales/SampleHistory';
import { apiSelectItemList } from '@/api/item/master.js';

export default {
	props: ['headers'],
	data: function() {
		return {
			backUri: '/sales/sample',

			mode: 'add',

			sample: {
				sample_dn: null,
			},

			popup_items: [],

			//acClasses: [],
			//acSelected: null,

			items: [],
			item_nos_to_delete: [],

			salesGroups: [],

			sampleStatusCodes: [],

			allSelected: false,

			itemClass: null,
			keyword: '',
			searchItems: [],

			modalName: '',
			showModal: false,
			historyModal: false,
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	watch: {
		sample: {
			deep: true,
			handler: function() {
				this.calTotal();
			},
		},
		items: {
			deep: true,
			handler: function() {
				this.calTotal();
			},
		},
	},
	components: {
		CodeSelect,
		CustomDatePicker,
		ItemPopupSample,
		Modal,
		SampleHistory,
	},
	methods: {
		copyItems() {
			//console.log('copy');
			if (this.items.filter(i => i.selected).length == 0) {
				this.$toast.error('No items selected');
				return;
			}
			if (this.items.filter(i => i.selected).length > 500) {
				this.$toast.error('Too many items');
				return;
			}

			var c_items = _.cloneDeep(this.items.filter(i => i.selected));
			c_items.forEach(function(i) {
				i.sample_item_no = null;
			});

			if (c_items.length > 0) {
				this.$session.set('sample-items', c_items);
				this.$toast.success('Item copied');
			}
		},
		async pasteItems() {
			var item_ids = [];
			this.$session.get('sample-items').forEach(i => {
				item_ids.push(i.item_id);
			});

			var param = {
				item_ids: item_ids,
				for_sale: true,

				include_available: true,
				include_on_board: true,
			};

			const { data } = await apiSelectItemList(param);
			var pItemList = data.itemList;
			var vm = this;
			pItemList.forEach(item => {
				var foundItems = vm.$session.get('sample-items').filter(i => i.item_id == item.item_id);
				if (foundItems.length > 0) item.request_quantity = foundItems[0].request_quantity;
				item.pastedItem = true;
			});

			this.mergeItems(pItemList);

			//console.log(copiedItems);
		},
		selectClasses(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&keyword=' + input;
			//if (this.invoice.invoice_type == 'R') url += '&include_closed_yn=Y';

			//console.log(url);
			return url;
			//return process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&keyword=' + input;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			this.itemClass = c.selectedObject.code;
			this.search();
			//this.searchKeyword(c.selectedObject.code);

			//console.log(str);
		},
		searchKeyword(keyword) {
			//console.log(keyword);
			this.$refs.ac.clear();
			this.keyword = keyword;
			this.search();
		},

		selectItem(item) {
			this.$router.push({ name: 'itemMaster', params: {}, query: { backUri: this.$route.fullPath, keyword: item.item_id } });
		},

		setItemClass(itemClass) {
			//console.log('hmmm', itemClass);
			this.itemClass = itemClass.code;
			//console.log(this.itemClass);
			//console.log('set item class');
			this.search();
		},
		async search() {
			this.openModal('ItemSelect');
		},
		reset() {
			this.keyword = '';
			this.itemClass = null;
		},
		deleteItems() {
			for (var i = this.items.length - 1; i >= 0; i--) {
				if (this.items[i].selected) {
					if (this.items[i].sample_item_no) this.item_nos_to_delete.push(this.items[i].sample_item_no);
					this.items.splice(i, 1);
				}
			}
		},
		selectAll() {
			//console.log(this.allSelected);
			var vm = this;
			this.items.forEach(function(item) {
				item.selected = vm.allSelected;
			});
		},

		calTotal() {},

		async selectSample() {
			const { data } = await apiSelectSample({
				sample_no: this.sample.sample_no,
			});

			this.sample = data.sample;
			this.items = data.sampleItemList;

			this.sample.org_status_code = this.sample.status_code;

			if (this.sample.status_code == 'W') {
				this.items.forEach(i => {
					i.pick_quantity = i.request_quantity < i.available_quantity ? i.request_quantity : i.available_quantity;
				});
			}
		},
		async checkInactiveItemExists() {
			const { data } = await apiCheckInactiveItemExists({ items: this.items });
			if (data.result) {
				this.$toast.error('Inactive item(s) exist(s)');
				return true;
			} else {
				return false;
			}
		},
		checkValidity() {
			if (!this.sample.entry_date) {
				this.$toast.error('Empty Entry Date');
				return false;
			}

			if (!this.sample.sales_group_code) {
				this.$toast.error('Empty Sales Group Code');
				return false;
			}

			return true;
		},
		async deleteSample() {
			if (confirm('Are you sure to delete?')) {
				const { data } = await apiDeleteSample(this.sample);
				if (data.result) {
					this.$toast.success('Deleted successfully');
					this.$router.push(this.backUri);
				} else {
					this.$toast.error('Failed');
				}
			}
		},
		async makeVoid(stay) {
			this.sample.status_changed = true;
			this.sample.status_code = 'V';
			await this.submit(stay, this.sample.org_status_code == 'D');
		},
		async request(stay) {
			if (this.checkValidity()) {
				if (!(await this.checkInactiveItemExists())) {
					this.sample.status_changed = true;
					this.sample.status_code = 'R';
					await this.submit(stay, false);
				}
			}
		},
		async approve(stay) {
			if (this.checkValidity()) {
				if (!(await this.checkInactiveItemExists())) {
					this.sample.status_changed = true;
					this.sample.status_code = 'A';
					await this.submit(stay, false);
				}
			}
		},
		async ready(stay) {
			if (this.checkValidity()) {
				if (this.items.filter(i => i.pick_quantity > 0).length != this.items.length) {
					this.$toast.error('Invalid pick quantity');
					return;
				}
				this.sample.status_changed = true;
				this.sample.status_code = 'D';
				await this.submit(stay, false);
			}
		},
		async sreturn(stay) {
			if (this.checkValidity()) {
				this.sample.status_changed = true;
				this.sample.status_code = 'T';
				await this.submit(stay, false);
			}
		},

		async save(stay) {
			if (this.checkValidity()) {
				if (!(await this.checkInactiveItemExists())) {
					await this.submit(stay, false);
				}
			}
		},
		cancel() {
			this.$router.push(this.backUri);
		},
		async submit(stay, decrease_on_hand) {
			//console.log(this.items);
			var total_request_quantity = 0;
			var total_pick_quantity = 0;

			this.items.forEach(i => {
				if (i.request_quantity) total_request_quantity += i.request_quantity;
				if (i.pick_quantity) total_pick_quantity += i.pick_quantity;
			});
			this.sample.total_request_quantity = total_request_quantity;
			this.sample.total_pick_quantity = total_pick_quantity;

			this.sample.items = this.items;
			this.sample.item_nos_to_delete = this.item_nos_to_delete;

			// this.$toast.info('Under Development');
			// var dummy = true;
			// if (dummy) {
			// 	console.log(this.sample, stay);
			// 	return;
			// }

			var response;
			if (this.mode == 'add') {
				response = await apiInsertSample(this.sample);
			} else {
				if (decrease_on_hand) this.sample.decrease_on_hand = decrease_on_hand;
				response = await apiUpdateSample(this.sample);
			}
			var data = response.data;

			if (data.result) {
				this.$toast.success('Saved successfully');

				//console.log(this.backUri);
				if (!stay) {
					this.$router.push(this.backUri);
				} else {
					if (this.mode == 'add') {
						this.sample.sample_no = data.sample_no;

						this.mode = 'detail';
						this.$store.commit('setSubTitle', 'Sample -> Detail');
					}
					await this.selectSample();
				}
			} else {
				this.$toast.error(data.msg);
			}
		},

		openModal(modalName) {
			this.modalName = modalName;
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},

		addItems(items) {
			var to_add_items = [];
			items.forEach(function(item) {
				item.request_quantity = item.quantity;
				to_add_items.push(item);
			});

			this.mergeItems(to_add_items);

			this.reset();
		},
		mergeItems(items) {
			var vm = this;
			items.forEach(function(item) {
				var foundItems = vm.items.filter(i => i.item_id == item.item_id);
				if (foundItems.length > 0) foundItems[0].request_quantity += item.request_quantity;
				else vm.items.push(_.cloneDeep(item));
			});
		},
		async index() {
			const { data } = await apiIndex();

			// this.paymentTerms = data.paymentTermList;
			// this.shipCharges = data.shipChargeList;
			this.salesGroups = data.salesGroupList;
			// this.deliveryTypes = data.deliveryTypeList;
			// this.returnTypes = data.returnTypeList;
			// this.remarks = data.remarkList;
			// this.specialSales = data.specialSaleList;
			// this.locationList = data.locationList;
		},
		async init() {
			await this.index();
			this.sampleStatusCodes = this.$sampleStatusCodes;

			// var response;

			if (this.mode == 'detail') {
				await this.selectSample();
			}
			inputSelectOnClick();
		},
		// async test() {
		// 	const { data } = await apiInsertInvoice(this.invoice);

		// 	if (data.result) {
		// 		this.$toast.success('Saved successfully');
		// 	} else {
		// 		this.$toast.error(data.msg);
		// 	}
		// },
		print() {
			apiSelectSample({ sample_no: this.sample.sample_no, order_by: 'P', print: 'Y' }).then(xhr => {
				reportRenderBase64(xhr.data, 'SampleRequest', reportMrtUrl('SampleRequest'));
			});
		},

		HistoryModalShowChange() {
			this.historyModal = !this.historyModal;
		},
	},
	created() {
		this.sampleStatusCodes = this.$;
		if (this.$route.query.backUri) this.backUri = this.$route.query.backUri;
		this.mode = this.$route.params.mode;

		this.$store.commit('setSideIndex', 3);
		this.$store.commit('setSelectedMenu', 'nav_li_sample');

		if (this.mode == 'add') {
			this.$store.commit('setSubTitle', 'Sample -> Add');
			this.sample.entry_date = today();
		} else {
			this.$store.commit('setSubTitle', 'Sample -> Detail');
			this.sample.sample_no = this.$route.query.sample_no;

			if (!this.sample.sample_no) {
				//console.log('empty...', this.backUri);
				this.$router.push(this.backUri);
				return;
			}
		}

		this.init();
		//console.log(this.user);

		// this.selectDepts();
		// this.selectSalesTeams();
	},
	mounted() {
		inputSelectOnClick();
		//$(this.$refs.invoice_items).floatThead({ zIndex: 1, autoReflow: true });

		// if (this.mode == 'add') {
		// 	this.$nextTick(function() {
		// 		this.$refs.shipto.$el.children[0].focus();

		// 	});
		// }
	},
};
</script>

<style>
td a:hover {
	text-decoration: underline;
	color: #ff0000;
}
</style>
